import dayjs from 'dayjs';
import { isoDayOfWeekFromJsDay } from 'shared/checkin-days';

/**
 * The next standup day strictly after `fromDate`, as a YYYY-MM-DD string, or
 * nothing when there is no further standup. `days` are ISO day numbers
 * (Monday = 1 ... Sunday = 7); dayjs counts Sunday as 0, so the numbering is
 * converted here.
 *
 * `endDate` matters on the closing day itself: a course whose window ends on
 * a day it does not collect would otherwise promise a standup that can never
 * open.
 */
export function nextCheckinDay(
  fromDate: string,
  days: number[],
  endDate?: string,
): string | undefined {
  if (!days.length) {
    return undefined;
  }
  let cursor = dayjs(fromDate);
  for (let i = 0; i < 7; i += 1) {
    cursor = cursor.add(1, 'day');
    const dow = isoDayOfWeekFromJsDay(cursor.day());
    if (days.includes(dow)) {
      const iso = cursor.format('YYYY-MM-DD');
      return endDate && iso > endDate ? undefined : iso;
    }
  }
  return undefined;
}
